import Icon from '../components/Icon.vue'

Icon.register({
  genderless: {
    width: 288,
    height: 512,
    paths: [
      {
        d: 'M144 176c-44.1 0-80 35.9-80 80s35.9 80 80 80 80-35.9 80-80-35.9-80-80-80zM144 112c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/genderless.js
// module id = 1379
// module chunks = 0